import { useEffect, useState } from 'react';
import {
  DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton,
  GridToolbarDensitySelector, GridToolbarExportContainer, GridCsvExportMenuItem, esES,
  GridPrintExportMenuItem, gridClasses
} from '@mui/x-data-grid';
import jwt_decode from "jwt-decode";
import { Breadcrumbs, Card, CardContent, CardHeader, Grid, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import 'dayjs/locale/es-mx.js'
import { useLocation } from 'react-router-dom';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

dayjs.locale('es-mx')

const csvOptions = { utf8WithBom: true };
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
}

const CustomExportButton = (props) => (
  <GridToolbarExportContainer {...props}>
    <GridCsvExportMenuItem options={csvOptions} />
    <GridPrintExportMenuItem options={printOptions} />
  </GridToolbarExportContainer>
);

const CustomToolbar = (props) => (
  <GridToolbarContainer {...props}>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <GridToolbarDensitySelector />
    <CustomExportButton />
  </GridToolbarContainer>
);

export default function Saldo() {
  const navigate = useNavigate()
  const location = useLocation();
  const { nombreArchivo, fecha, anio } = location.state || {};
  const [data, setData] = useState({ columns: [], rows: [] })
  const [pageSize, setPageSize] = useState(15)
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    fecha: false,
  });

  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token);
  const obtenerReglas = () => {
    let reglas
    const perfilElegido = sessionStorage.getItem('perfilElegido')
    switch (perfilElegido) {
      case 'asistente':
        reglas = decoded.rulesAsistente
        break
      case 'investigador':
        reglas = decoded.rulesJefaturaArea
        break
      case 'coordinacion':
        reglas = decoded.rulesCoordinacion
        break
      case 'jefe':
        reglas = decoded.rulesJefatura
        break
      case 'administracion':
        reglas = decoded.rulesAdministracionProyecto
        break
      default:
        break
    }
    return reglas
  }

  let reglas = decoded.rules

  if (!reglas)
    reglas = obtenerReglas()

  useEffect(() => {
    (async () => {
      const resSaldos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteSaldo/importarExcel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil'),
          "identidad": sessionStorage.getItem('idEntidad'),
          "identidadsuperior": sessionStorage.getItem('idEntidadSuperior')
        },
        body: JSON.stringify({
          "file": nombreArchivo,
          "anio": anio
        })
      })

      const respuesta = await resSaldos.json()

      const customColumnNames = [
        'FUENTE DE FINANCIAMIENTO',
        'PROYECTO/UNIDAD',
        'NOMBRE PROY.',
        'N. ECONOMICO',
        'RESPONSABLE',
        'PARTIDA SUBESPECIFICA',
        'DESCRIPCION',
        'INICIAL',
        'ADECUACIONES',
        'TRANSFERENCIAS',
        'MODIFICADO',
        'PRECOMPROMETIDO',
        'COMPROMISO',
        'EJERCICIO DEL',
        'EJERCICIO AL',
        'GASTO',
        'DIFERENCIA',
        'PORCENTAJE'
      ];


      const datos = {
        columns: Object.keys(respuesta.registros[0]).map((key, index) => ({
          field: key,
          headerName: customColumnNames[index] || `Columna ${index + 1}`,
          width: 180,
          sortable: true,
          filterable: true,
          type: (index >= 6) ? 'number' : 'string',
          /*renderCell: Number(index) === Number(0) ? (params) => <span>{Number(params.value) === 1 ? 'Subsidio federal' : Number(params.value) === 2 ? 'Ingresos propios no adecuables' : Number(params.value) === 7 ? 'Ingresos propios adecuables' : Number(params.value) === 8 ? 'Remanentes' : params.value}</span>
            : Number(index) === Number(1) ? (params) => <span>{params.value}-{respuesta.proyectos.filter(proyecto => Number(proyecto.clave) === Number(params.value))[0] ? respuesta.proyectos.filter(proyecto => Number(proyecto.clave) === Number(params.value))[0].descripcion : ''} <strong>{respuesta.proyectos.filter(proyecto => Number(proyecto.clave) === Number(params.value))[0] ? respuesta.proyectos.filter(proyecto => Number(proyecto.clave) === Number(params.value))[0].responsable : ''}</strong></span> : undefined,*/
          valueGetter: (params) => {
            if (Number(index) === Number(0)) {
              return `${Number(params.value) === 1 ? 'Subsidio federal' : Number(params.value) === 2 ? 'Ingresos propios no adecuables' : Number(params.value) === 7 ? 'Ingresos propios adecuables' : Number(params.value) === 8 ? 'Remanentes' : params.value}`
            }
            if (Number(index) === 1) {
              const proyecto = respuesta.proyectos.find(proyecto =>
                String(proyecto.clave.trim()).localeCompare(String(params.value.trim())) === 0
              );
              if (proyecto)
                return `${params.value}`
            }

            if (Number(index) === 2) {
              const claveColumna1 = params.row[datos.columns[1].field]; // Obtener el valor de la columna 1
              const proyecto = respuesta.proyectos.find(proyecto =>
                String(proyecto.clave.trim()).localeCompare(String(claveColumna1?.trim())) === 0
              );
              if (proyecto)
                return `${proyecto.descripcion}`;
              else
                return ''
            }
            if (Number(index) === 3) {
              const claveColumna1 = params.row[datos.columns[1].field]; // Obtener el valor de la columna 1
              const proyecto = respuesta.proyectos.find(proyecto =>
                String(proyecto.clave.trim()).localeCompare(String(claveColumna1?.trim())) === 0
              );

              if (proyecto) {
                const econ = proyecto.responsable.slice(0, 5)
                return `${econ}`
              }
              else
                return ''
            }
            if (Number(index) === 4) {
              const claveColumna1 = params.row[datos.columns[1].field]; // Obtener el valor de la columna 1
              const proyecto = respuesta.proyectos.find(proyecto =>
                String(proyecto.clave.trim()).localeCompare(String(claveColumna1?.trim())) === 0
              );
             
              if (proyecto) {
                const nombre = proyecto.responsable.slice(6)
                return `${nombre}`
              }
              else
                return ''
            }

            if (Number(index) >= 5) {
              const claveColumna = params.row[datos.columns[index-3].field];
              return claveColumna.toLocaleString().replace(/,/g, '');  // Elimina las comas

            }

            return params.value;
          },
          valueFormatter: (params) => {
            if (index >= 7 && index < 17) {
              return Number(params.value).toLocaleString("es-MX", { style: "currency", currency: "MXN" });
            }
            return params.value
          }

        })),
        rows: respuesta.registros.map((registro, index) => ({
          id: index,
          ...registro
        }))
      }


      setData(datos)




    })();
    // eslint-disable-next-line
  }, [/*solicitud, ocultarContratos*/]
  )

  return (
    <><div role="presentation" style={{ marginTop: '20px' }} >
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          href="javascript:void(0)" onClick={() => { navigate(-1) }}
        >
          <KeyboardReturnIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Regresar
        </Link>
      </Breadcrumbs>
    </div>
      <div style={{ display: 'flex', marginTop: '50px' }}>
        <Grid container rowSpacing={2} columnSpacing={5}>
          <Grid item xs={12} md={12}>
            <Card style={{ height: '100%', width: '100%' }}>
              <CardHeader title={`Saldo al ${fecha}`}></CardHeader>
              <CardContent sx={{ height: 700 }}>
                <DataGrid {...data} pageSize={pageSize} getRowHeight={() => 'auto'} getRowId={(row) => row.id} sx={{
                  [`& .${gridClasses.cell}`]: {
                    py: 1,
                  },
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                }}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}

                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel) => {
                    // Forzar la columna 'fecha' a permanecer oculta
                    setColumnVisibilityModel((prevModel) => ({
                      ...newModel,
                      fecha: false,
                    }));
                  }}
                >
                </DataGrid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
}